import { Bot, User } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { StreamingIndicator } from './StreamingIndicator';
import { ModelInfoBadge } from './ModelInfoBadge';

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  content: string;
  isStreaming?: boolean;
  modelInfo?: {
    displayName: string;
    tier: string;
  } | null;
}

export function MessageBubble({ role, content, isStreaming, modelInfo }: MessageBubbleProps) {
  if (role === 'user') {
    return (
      <div className="flex gap-4 justify-end">
        <div className="max-w-[80%] rounded-2xl px-4 py-3 bg-primary text-primary-foreground">
          <div className="whitespace-pre-wrap break-words">{content}</div>
        </div>
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary flex items-center justify-center">
          <User className="h-4 w-4 text-primary-foreground" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3 justify-start">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
        <Bot className="h-4 w-4 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs text-muted-foreground">Fias AI</span>
          {modelInfo && (
            <ModelInfoBadge displayName={modelInfo.displayName} tier={modelInfo.tier} />
          )}
        </div>
        <div className="bg-muted rounded-2xl px-4 py-3">
          {content ? (
            <div className="prose prose-sm dark:prose-invert max-w-none break-words [&>*:first-child]:mt-0 [&>*:last-child]:mb-0">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          ) : isStreaming ? (
            <StreamingIndicator />
          ) : null}
          {content && isStreaming && <StreamingIndicator />}
        </div>
      </div>
    </div>
  );
}
